import React, { Component } from 'react';
import { connect } from 'react-redux';
// utils
import { Translations, formApiUrl, loadIfStateAvailableInSessionStorageLevel2 } from '../../../../utils/';
// constant
import { FORM_REFS } from '../../../../constants';
// restClient
import { aemHostClient, eapiClient, taxonomyHostClient } from '../../../../restClient';
// children
import Dynamicform from '../../../common/Dynamicform/dynamicForm';
import { resetCountryInfo } from '../../../createAcase/actions/actionCreator';
import { setCurrentProductAllAccounts } from '../../actions/actionCreator';
//style
import './styles.css';

class CreateNewEchannelOtherAccount extends Component {
  constructor(props) {
    super(props)
    this.state = {
      formData: {},
      existingEntityData: [],
      accountsData: [],
      filterAccounts: []
    }
    this.disableList = [];
    this.mode = "";
  }

  componentWillMount() {
    this.props.resetCountryInfo();
    var prevStatePresent = loadIfStateAvailableInSessionStorageLevel2(this, null, () => {
      this.loadPageState();
    });
    let _caseId = Object.keys(this.props.cases)[0]

    let _url = "/entities/existing-organisations/" + _caseId;
    eapiClient(_url)
      .then(({ data }) => {
        this.setState({
          ...this.state,
          existingEntityData: data.responseData
        }, () => { })
      });


  }

  componentWillReceiveProps(nextProps) {
    if (this.props.lang.currentLang.lang !== nextProps.lang.currentLang.lang) {
      this.getCountryListForOtherAcc();
    }
  }

  loadPageState = () => {
    let apiURL = "/aemData/formData/json_create-existing-account-new-echannel";
    if (this.props.mode === "edit") {
      apiURL = apiURL.replace("create-", "edit-");
    }

    aemHostClient(apiURL)
      .then(({ data }) => {
        document.title = `${Translations(data.par.page_title_mainTitle.pageHeading, this.props.lang.currentLang.lang, this.props.lang.translatedData)} - ${'HSBC GLCM'}`;
        this.setState({ formJson: data });
        let _caseId = Object.keys(this.props.cases)[0]
        let accountUrl = "/product/other/accounts/" + _caseId;
        eapiClient(accountUrl)
          .then(({ data }) => {
            this.setState({
              ...this.state,
              accountsData: data.responseData
            })
            this.props.setCurrentProductAllAccounts(data.responseData);
            this.getCountryListForOtherAcc();
          })
      });
  }

  getCountryListForOtherAcc = () => {
    let _currentaccountsData = [...this.props.accountsData];
    taxonomyHostClient(Translations(this.state.formJson.par.aemform_.countryTaxonomy, this.props.lang.currentLang.lang, this.props.lang.translatedData))
      .then(({ data }) => {
        let currentListCountries = data.responseData.classificationNodes;
        _currentaccountsData = _currentaccountsData.map(item => {
          currentListCountries.filter(country => {
            if (country.id === item.country.value) {
              item.country.name = country.name
            }
          })
          return item;
        })
        this.props.setCurrentProductAllAccounts([..._currentaccountsData]);
      });
  }

  getFormData = (formData) => {
    this.disableList.pop();
    let getCurrentDropDown = window.sessionStorage.getItem("getCurrentDropDown");
    let getCurrentDropDownValue = window.sessionStorage.getItem('key' + getCurrentDropDown);
    var filterAccounts = [];
    let _otherEntityAccountHolder;
    var _formData = formData;
    if (_formData['otherEntityAccountHolder'] !== undefined && this.state.formData.otherEntityAccountHolder) {
      if (_formData['otherEntityAccountHolder'].value !== this.state.formData.otherEntityAccountHolder.value) {
        delete _formData['tradingName'];
        if (this.state.formData.otherEntityAccountHolder.value !== 'other')
          delete _formData['accountId'];
      }

    } if (_formData['accountHolder'] !== undefined && this.state.formData.accountHolder) {
      if (_formData['accountHolder'].value !== this.state.formData.accountHolder.value) {
        delete _formData['accountId'];
      }
    }
    this.disableList.push(formData.accountId)
    if (formData['accountHolder'] !== undefined) {
      filterAccounts = this.props.accountsData.filter(item => item.accountHolder.value === formData['accountHolder'].value)
    } else if (formData['otherEntityAccountHolder'] !== undefined && formData['otherEntityAccountHolder'].value !== 'other') {
      filterAccounts = this.props.accountsData.filter(item => item.accountHolder.value === formData['otherEntityAccountHolder'].value)
    } else if (getCurrentDropDownValue !== null && (formData['tradingName'] !== undefined || (formData['otherEntityAccountHolder'] !== undefined && formData['otherEntityAccountHolder'].value === 'other'))) {
      let _existingEntityData = this.props.existingEntityData;
      let _existingEntityVal = _existingEntityData[_existingEntityData.length - 2] || {};
      filterAccounts = this.props.accountsData.filter(item => item.accountHolder.value === _existingEntityVal.id)
      _otherEntityAccountHolder = {
        name: _existingEntityVal.existingEntityName,
        value: _existingEntityVal.id
      };
      _formData = {
        ...formData,
        otherEntityAccountHolder: _otherEntityAccountHolder
      }
    }

    this.setState({
      formData: _formData,
      disabledList: this.disableList,
      filterAccounts
    }, () => { });
    window.sessionStorage.removeItem("getCurrentDropDown");
    window.sessionStorage.removeItem('key' + getCurrentDropDown);
  }

  onFormSubmit = (event, apiURL) => {
    var requestData = { ...this.state.formData };
    if (this.props.mode === 'edit') {
      apiURL = apiURL + "/" + this.state.formData.id;
    }

    var METHOD = this.props.mode === 'edit' ? 'PUT' : 'POST';
    eapiClient(formApiUrl(apiURL, ":echannelId", this.props.echannelId), {
      method: METHOD,
      data: JSON.stringify(requestData)
    })
      .then(({ data, status }) => {
        if (status === 201 || status === 200) {
          this.props.history.goBack();
        }
      });
  }

  onFormCancel = () => {
    this.props.history.goBack();
  }

  renderFormGroups() {
    let formData, setAccountBtnOnCancel;
    if (Object.keys(this.state.formData).length > 0 || this.props.currentOtherAccount !== undefined) {
      formData = { ...this.state.formData };
      this.mode = "edit"
      if (Object.keys(this.state.formData).length >= 3) {
        setAccountBtnOnCancel = true;
      } else {
        setAccountBtnOnCancel = false;
      }
    } else {
      formData = {};
    }
    const properties = {
      otherAccountId: this.props.match.params.otherAccountId,
      formData,
      existingEntityData: this.state.existingEntityData,
      editType: 'create-new-echannel-other-account',
      pathname: this.props.history.location.pathname
    };
    if (this.state.formJson !== undefined && this.state.formJson.par.aemform_ !== undefined) {
      return (
        <Dynamicform mode={this.mode}
          properties={properties}
          url={FORM_REFS[this.state.formJson.par.aemform_.formRef]}
          getFormData={this.getFormData}
          history={this.props.history}
          match={this.props.match}
          onFormSubmit={this.onFormSubmit}
          onFormCancel={this.onFormCancel}
          lang={this.props.lang.currentLang.lang}
          translatedData={this.props.lang.translatedData}
          flag={this.props.lang.currentLangFlag.flag}
          pageState={this.state}
          accountsData={this.state.filterAccounts}
          disabledList={this.disableList}
          previousPageLevel2={true}
          setValidationForAccounts={true}
          setAccountBtnOnCancel={setAccountBtnOnCancel}
          requiredFields={{
            "row1": ["accountNumber"],
            "row2": ["bankName", "branchCode"],
            "row3": ["currency", "country"]
          }}
          productType={"gls-echannel-create-other-account"}
        />
      );
    }
  }

  render() {
    const pageTitle = this.state.formJson ? this.state.formJson['par'].page_title_mainTitle : '';
    return (
      <div className="form-container">
        <div className="form-title">
          <h2 className="form-heading">
            {Translations(pageTitle.pageHeading, this.props.lang.currentLang.lang, this.props.lang.translatedData)}
          </h2>
          <p className="form-required-desc">
            {Translations(pageTitle.descriptionText, this.props.lang.currentLang.lang, this.props.lang.translatedData)}
          </p>
        </div>
        {this.renderFormGroups()}
      </div>
    );
  }
}

const mapStateToProps = (state, props) => {
  let currentEchannelOtherAccounts = window.sessionStorage.getItem('previousPageState');
  let parseOtherAccountData = JSON.parse(currentEchannelOtherAccounts);
  let currentOtherAccount = undefined;
  let _accountsData = [];
  if (props.match.params) {
    var { otherAccountId } = props.match.params;
    if (otherAccountId && state.currentProductEchannel.data.otherAccounts.length > 0) {
      state.currentProductEchannel.data.otherAccounts.forEach(otherAccount => {
        if (otherAccount.id === otherAccountId) {
          currentOtherAccount = otherAccount;
        }
      });
    }
  }
  if (state.currentProductEchannel.currentProductAllAccounts !== undefined && parseOtherAccountData !== null) {
    if (parseOtherAccountData.currentEchannel.otherAccounts !== undefined) {
      _accountsData = state.currentProductEchannel.currentProductAllAccounts.filter(entry1 => !parseOtherAccountData.currentEchannel.otherAccounts.some(entry2 => entry1.id === entry2.id));
    } else {
      _accountsData = state.currentProductEchannel.currentProductAllAccounts
    }
    if (parseOtherAccountData.accountsReportingToEchannel !== undefined) {
      _accountsData = _accountsData.filter(entry1 => !parseOtherAccountData.accountsReportingToEchannel.some(entry2 => entry1.id === entry2.id))
    } else {
      _accountsData = state.currentProductEchannel.currentProductAllAccounts
    }
  }

  return {
    echannelId: state.currentProductEchannel.data.id,
    currentOtherAccount,
    mode: currentOtherAccount !== undefined ? 'edit' : '',
    lang: state.lang,
    cases: state.cases,
    accountsData: _accountsData,
    existingEntityData: state.currentProductEchannel.existingEntityData
  };
}
const mapDispatchToProps = dispatch => {
  return {
    setCurrentProductAllAccounts: productEchannelAccountData => {
      dispatch(setCurrentProductAllAccounts(productEchannelAccountData))
    },
    resetCountryInfo: () => {
      dispatch(resetCountryInfo())
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(CreateNewEchannelOtherAccount);



// WEBPACK FOOTER //
// ./src/components/CaseBody/ProductRequests/CaptureProductEchannel/CreateNewEchannelOtherAccount.js